import { render, staticRenderFns } from "./studentSttings.vue?vue&type=template&id=7dff28b9&"
import script from "./studentSttings.vue?vue&type=script&lang=js&"
export * from "./studentSttings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports